import civ from '../../../constants/civ'
import { feeValue } from '../../../lib/numbers'
import {
  round2,
  stripeAchFee,
  stripeCardFee,
} from '../../../lib/sponsorPledgeFlowMath'

const PLATFORM_FEE_KEYS = [
  'influencer_fee',
  'civillos_expense_fee',
  'cirrusmio_profit_fee',
]

export function platformFeesReady(platformFees) {
  if (!platformFees) return false
  return PLATFORM_FEE_KEYS.every(key => platformFees[key] != null)
}

export function computePlatformServiceFee(amount, platformFees) {
  if (!platformFees) return 0
  return PLATFORM_FEE_KEYS.reduce((sum, key) => {
    const fee = platformFees[key]
    if (!fee) return sum
    return round2(sum + (feeValue(String(amount || 0), fee) ?? 0))
  }, 0)
}

/** Sum of loaded platform fee percentages (e.g. ~9%). */
export function computePlatformServiceFeePct(platformFees) {
  if (!platformFees) return null
  let pct = 0
  let hasPct = false
  for (const key of PLATFORM_FEE_KEYS) {
    const fee = platformFees[key]
    if (!fee || fee.fee_kind !== civ.fee_kind.percentage) continue
    pct += Number(fee.value) || 0
    hasPct = true
  }
  if (!hasPct) return null
  return round2(pct)
}

export function computeReviewFeeTotals({
  commitmentNum,
  opsAmount,
  platformFees,
}) {
  const c = Number(commitmentNum) || 0
  const serviceAmt = computePlatformServiceFee(c, platformFees)
  const serviceFeePct = computePlatformServiceFeePct(platformFees)
  const opsNum = round2(Math.max(0, parseFloat(opsAmount) || 0))
  const reviewSubtotal = round2(c + opsNum)
  const preStripeForProcessing = round2(reviewSubtotal + serviceAmt)
  const achFee = stripeAchFee(preStripeForProcessing)
  const cardFee = stripeCardFee(preStripeForProcessing)
  const totalAch = round2(preStripeForProcessing + achFee)
  const totalCard = round2(preStripeForProcessing + cardFee)
  return {
    serviceAmt,
    serviceFeePct,
    opsNum,
    reviewSubtotal,
    preStripeForProcessing,
    achFee,
    cardFee,
    totalAch,
    totalCard,
  }
}

export function computeVpfShares(vpfAmount) {
  const v = Number(vpfAmount) || 0
  const vpfVolunteerShare = round2(v / 2)
  const vpfOrgShare = round2(v - vpfVolunteerShare)
  return { vpfVolunteerShare, vpfOrgShare }
}
